import React from "react"

const Message = ({ children }) => {
    return (
        <div className="message">
            {children}
        </div>
    )
}

export default Message